import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { getBackendURL } from '../../utils/backendURL';

export default function OpsOrganizationRole({ user }) {
  const [ownerId, setOwnerId] = useState(null);
  const [error, setError] = useState(false);
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    const controller = new AbortController();
    setOwnerId(null);
    setError(false);
    axios.get(`${getBackendURL()}/api/ops/users/${encodeURIComponent(user.id)}/organization`, {
      params: { limit: 1 }, signal: controller.signal,
      headers: { Authorization: `Bearer ${localStorage.getItem('admin_token')}` },
    }).then(({ data }) => {
      if (!controller.signal.aborted) {
        if (data.organization?.owner_id) setOwnerId(data.organization.owner_id);
        else setError(true);
      }
    }).catch(() => { if (!controller.signal.aborted) setError(true); });
    return () => controller.abort();
  }, [user.id, attempt]);
  if (error) return <p>Organization role: Unavailable. <button className="text-blue-700 underline"
    onClick={() => setAttempt(value => value + 1)}>Retry role</button></p>;
  const role = ownerId === null ? 'Loading…' : ownerId === user.id ? 'Owner'
    : user.role === 'admin' ? 'Team Admin' : 'Team Member';
  return <p>Organization role: {role}</p>;
}
